/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cat_health_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body, nutrition and training calculators.`)
};

const es_cat_health_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras de cuerpo, nutrición y entrenamiento.`)
};

const de_cat_health_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechner für Körper, Ernährung und Training.`)
};

const nl_cat_health_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekenmachines voor lichaam, voeding en training.`)
};

const fr_cat_health_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corps, nutrition et calculateurs d'entraînement.`)
};

const it_cat_health_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatori per corpo, alimentazione e allenamento.`)
};

const pt_br2_cat_health_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras de corpo, nutrição e treino.`)
};

const pt_cat_health_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadoras de corpo, nutrição e treino.`)
};

const ja_cat_health_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身体、栄養、トレーニングの計算ツール。`)
};

const zh_cat_health_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身体、营养和训练计算器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cat_health_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cat_health_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cat_health_desc", locale)
	if (locale === "en") return en_cat_health_desc(inputs)
	if (locale === "es") return es_cat_health_desc(inputs)
	if (locale === "de") return de_cat_health_desc(inputs)
	if (locale === "nl") return nl_cat_health_desc(inputs)
	if (locale === "fr") return fr_cat_health_desc(inputs)
	if (locale === "it") return it_cat_health_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cat_health_desc(inputs)
	if (locale === "pt") return pt_cat_health_desc(inputs)
	if (locale === "ja") return ja_cat_health_desc(inputs)
	return zh_cat_health_desc(inputs)
};